import { videoLoaded } from '../../src/js/events';

export default class Animations {
  constructor() {
    const $components = document.querySelectorAll('[data-component]');

    this.components = [];

    const options = {
      root: null,
      threshold: 0.3
    };

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry, index) => {
        const { intersectionIndex } = entry.target;
        const component = this.components[intersectionIndex];
        const { animations } = component;

        if (entry.isIntersecting) {
          animations.forEach(animation => {
            if (animation.type === 'video' && !animation.video) {
              animation.video = new VideoAnimation(animation.$el);
            }
          });

          entry.target.classList.add('in-view');

        } else {
          entry.target.classList.remove('in-view');
        }
      });
    }, options);

    $components.forEach(($component, index) => {
      const animations = [];
      const $animations = $component.querySelectorAll('.js-animation');

      $animations.forEach($animation => {
        const animation = {
          '$el': $animation,
          'type': $animation.dataset.animationType
        };

        animations.push(animation);
      });

      this.components.push({
        '$component': $component,
        animations,
      });

      $component.intersectionIndex = index;

      observer.observe($component);
    });
  }
}

class VideoAnimation {
  constructor($el) {
    if (!$el || !$el.dataset.source || !$el.dataset.mime) return;

    this.$el = $el;

    const {
      mime,
      source,
      hoverOnly,
      poster,
      mp4Source,
      mp4Mime,
      disableOnMobile,
      loop
    } = this.$el.dataset;

    if (disableOnMobile === 'true' && window.innerWidth < 1024) {
      return;
    }

    const isHoverOnly = JSON.parse(hoverOnly.toLowerCase()) || false;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    this.$video = document.createElement('video');

    if (!isSafari || isSafari && !mp4Source) {
      this.$source = document.createElement('source');

      this.$source.src = source;
      this.$source.type = mime;

      this.$video.appendChild(this.$source);
    }

    else if (isSafari && mp4Source && mp4Mime) {
      const $mp4Source = document.createElement('source');

      $mp4Source.src = mp4Source;
      $mp4Source.type = mp4Mime;
      $mp4Source.codecs = "hvc1";
      $mp4Source.setAttribute('codecs', 'hvc1');

      this.$video.appendChild($mp4Source);
    }

    this.$video.muted = true;
    this.$video.autoplay = !isHoverOnly;
    this.$video.setAttribute('playsinline', true);
    this.$video.setAttribute('muted', true);

    if (loop === 'true') {
      this.$video.setAttribute('loop', true);
    }

    if (poster) {
      this.$video.setAttribute('poster', poster);
    }

    this.$el.appendChild(this.$video);
    this.$video.load();

    this.$video.onloadeddata = () => {
      if (!isHoverOnly) {
        this.$video.play();
      }

      window.dispatchEvent(new CustomEvent(videoLoaded, {
        detail: {
          el: this.$el,
        }
      }));
    }

    if (isHoverOnly) {
      const $animationHoverContainer = this.$el.closest('.js-animation-hover-container');

      if ($animationHoverContainer) {
        $animationHoverContainer.addEventListener('mouseenter', () => {
          this.$video.play();
        });

        $animationHoverContainer.addEventListener('mouseleave', () => {
          this.$video.pause();
          this.$video.currentTime = 0;
          this.$video.load();
        });
      } else {
        this.$el.addEventListener('mouseenter', () => {
          this.$video.play();
        });

        this.$el.addEventListener('mouseleave', () => {
          this.$video.pause();
          this.$video.currentTime = 0;
        });
      }
    }
  }
}
